import axios from 'axios'

const default_headers = ['withCredentials', 'crossDomain']

const setAxiosDefaultHeader = (flag, obj = {}) => {
	default_headers.forEach((key) => (axios.defaults[key] = !!flag))

	for (const [key, value] of Object.entries(obj)) {
		axios.defaults[key] = flag ? value ?? true : false
		axios.defaults.headers.common[key] = flag ? value ?? true : false
	}
}

export default setAxiosDefaultHeader
